var map = {
	"./GTCoS.pdf": 1377,
	"./GTCoS_en-TH.pdf": 1378,
	"./GTCoS_ko-KR.pdf": 1379,
	"./GTCoS_th-TH.pdf": 1380,
	"./GTCoS_vi-VN.pdf": 1381,
	"./GTCoS_zh-TW.pdf": 1382
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 102).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1312;
module.exports = webpackAsyncContext;